/* VetFamily Clarity: analytics consent required before any Microsoft request. */
(function () {
  'use strict';
  if (window.__vfClarityInstalled || !/^(shop\.|www\.)?vetfamily\.bg$/.test(location.hostname)) return;
  window.__vfClarityInstalled = true;
  var loaded = false, last = '';
  function cookies() {
    var out = {};
    document.cookie.split(';').forEach(function (part) { var i = part.indexOf('='); if (i < 0) return; try { out[part.slice(0, i).trim()] = decodeURIComponent(part.slice(i + 1)); } catch (_) {} });
    return out;
  }
  function consent() {
    if (location.hostname === 'shop.vetfamily.bg' && window.vfTracking) return window.vfTracking.getConsent();
    var c = cookies();
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && api.analyticsProcessingAllowed) {
      var current = api.currentVisitorConsent && api.currentVisitorConsent();
      if (current && ['yes','no'].indexOf(current.analytics) >= 0) return {analytics: current.analytics === 'yes', marketing: current.marketing === 'yes'};
    }
    var status = c.cookieconsent_status;
    if (status === 'deny' || status === 'decline') return {analytics:false,marketing:false};
    if (status === 'accept_all') return {analytics:true,marketing:true};
    if (status === 'allow' && c.cookieconsent_preferences_disabled !== undefined) {
      var blocked = c.cookieconsent_preferences_disabled.split(',');
      if (blocked.some(function(x){return x && ['analytics','marketing','functionality','strict'].indexOf(x)<0;})) return null;
      return {analytics:blocked.indexOf('analytics')<0,marketing:blocked.indexOf('marketing')<0};
    }
    return null;
  }
  function safe() {
    if (/^\/(account|checkouts|checkout|orders)(\/|$)/.test(location.pathname)) return false;
    try { return [location.href,document.referrer].every(function(raw){ if(!raw)return true;var u=new URL(raw);return !Array.from(u.searchParams).some(function(kv){return /email|phone|telephone|mobile|first_name|last_name|token/i.test(kv[0]) || /[^\s@]+@[^\s@]+\.[^\s@]+/.test(kv[1]);}); }); } catch(_){ return false; }
  }
  function update() {
    var c = consent();
    if (!c || !c.analytics || !safe()) {
      if (loaded) { window.clarity('consentv2',{analytics_Storage:'denied',ad_Storage:'denied'}); location.reload(); }
      return;
    }
    if (!loaded) {
      loaded = true;
      document.documentElement.setAttribute("data-clarity-mask", "true");
      window.clarity = window.clarity || function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
      window.clarity('consentv2',{analytics_Storage:'granted',ad_Storage:c.marketing?'granted':'denied'});
      window.clarity('set','vf_surface',location.hostname==='shop.vetfamily.bg'?'astro':'shopify');
      var script=document.createElement('script');script.async=true;script.id='vf-clarity';script.src='https://www.clarity.ms/tag/m0o9dy6r5v';document.head.appendChild(script);
    }
    var state=JSON.stringify(c);
    if(state!==last){window.clarity('consentv2',{analytics_Storage:'granted',ad_Storage:c.marketing?'granted':'denied'});last=state;}
  }
  ['vf:consent','vf:consent-ready','visitorConsentCollected'].forEach(function(name){document.addEventListener(name,update);});
  update();setInterval(update,1000);
})();
